export default __webpack_public_path__ + "static/media/240.a4f40e3c.jpg";